module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fzg-home-mobile"
  }, [_c('div', {
    staticClass: "fzg-slogan"
  }, [_c('fzg-menu'), _vm._v(" "), _c('img', {
    staticClass: "banner-bg",
    attrs: {
      "src": require("../../assets/img2/mobile/home/banner.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "banner-data",
    attrs: {
      "src": require("../../assets/img2/mobile/home/banner-data2.jpg"),
      "alt": ""
    }
  })], 1), _vm._v(" "), _vm._m(0, false, false), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('div', {
    staticClass: "section fzg-customer-comments"
  }, [_c('img', {
    staticClass: "comments-title",
    attrs: {
      "src": require("../../assets/img2/mobile/home/title-comments.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "logo-line"
  }, [_c('div', {
    staticClass: "item-area comment_nav_bar_item_wrap"
  }, _vm._l((_vm.comment_list), function(item) {
    return _c('div', {
      staticClass: "logo-item",
      class: {
        'logo-item-active': item.id === _vm.current_comment.id
      },
      on: {
        "click": function($event) {
          _vm.changeCurrentComment(item)
        }
      }
    }, [_c('div', {
      staticClass: "logo-wrap"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": item.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "dot"
    }, [_vm._v("●")])])
  })), _vm._v(" "), _c('div', {
    staticClass: "line-area"
  }, [_c('div', {
    staticClass: "line-area-center"
  }, [_c('div', {
    staticClass: "left",
    on: {
      "click": function($event) {
        _vm.showNextComment(-1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/main/arrow-right.png"),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "right",
    on: {
      "click": function($event) {
        _vm.showNextComment(1)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/main/arrow-right.png"),
      "alt": ""
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "comments-data"
  }, [_c('div', {
    staticClass: "intro-line"
  }, [(false) ? _c('p', [_vm._v("欣旺达电子股份有限公司（简称“欣旺达”）创立于1997年，于2011年在深交所上市（股票代码：300207），并于2022年成功发行GDR登陆瑞交所，是全球锂离子电池领域领军品牌。")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.current_comment.intro))])]), _vm._v(" "), _c('div', {
    staticClass: "comment-line"
  }, [_vm._m(2, false, false), _vm._v(" "), _c('div', {
    staticClass: "comment-content"
  }, [(false) ? _c('p', [_vm._v("本轮融资过程中，我们的投资人和财务顾问都表现出非常强的专业认知，以及对欣旺达EVB未来战略规划的深度理解和支持。中国动力电池事业发展任重道远，欣旺达一定不负众望，埋头苦干，坚持以成就客户、激情奋斗、团结合作为核心价值观，塑造具有全球影响力的品牌，为员工、股东以及整个中国锂电行业创造更大的价值。")]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v(" " + _vm._s(_vm.current_comment.content) + " ")])]), _vm._v(" "), _vm._m(3, false, false), _vm._v(" "), _c('div', {
    staticClass: "right-bottom"
  }, [_vm._v(" ——" + _vm._s(_vm.current_comment.name) + " ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "fzg-activity"
  }, [_c('img', {
    staticClass: "title-activity",
    attrs: {
      "src": require("../../assets/img2/mobile/home/fzg-title-activity.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "activity-area"
  }, [_vm._l((_vm.activity_list), function(item, index) {
    return _c('div', {
      staticClass: "act-item"
    }, [_c('a', {
      attrs: {
        "href": item.link,
        "target": "_blank"
      }
    }, [_c('div', {
      staticClass: "act-icon"
    }, [_c('img', {
      attrs: {
        "src": item.banner,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-content"
    }, [_c('div', {
      staticClass: "act-title"
    }, [_vm._v(_vm._s(item.title.length > 35 ? item.title.substr(0, 35) + '...' : item.title))]), _vm._v(" "), (false) ? _c('div', {
      staticClass: "act-content"
    }, [_vm._v(_vm._s(item.content.length > 40 ? item.content.substr(0, 40) + '...' : item.content))]) : _vm._e()])])])
  }), _vm._v(" "), _vm._m(4, false, false), _vm._v(" "), (false) ? _c('div', {
    staticClass: "act-item"
  }, [_c('img', {
    staticClass: "act-icon",
    attrs: {
      "src": require("../../assets/img2/pc/fzg-bussiness-icon1.jpg"),
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(5, false, false)]) : _vm._e()], 2)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section fzg-ecosystem"
  }, [_c('img', {
    staticClass: "eco-data",
    attrs: {
      "src": require("../../assets/img2/mobile/home/shengtai.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section fzg-ecosystem"
  }, [_c('img', {
    staticClass: "eco-data",
    attrs: {
      "src": require("../../assets/img2/mobile/home/bus-intro.jpg"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "left-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/main/bottom-comma.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-logo"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img2/pc/main/bottom-comma.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom-activity-links"
  }, [_c('a', {
    staticClass: "left-link",
    attrs: {
      "href": "/news"
    }
  }, [_vm._v("凡卓交易")]), _vm._v(" | "), _c('a', {
    staticClass: "right-link",
    attrs: {
      "href": "/news#activity"
    }
  }, [_vm._v("近期活动")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-content"
  }, [_c('div', {
    staticClass: "act-title"
  }, [_vm._v("小饭桌创服")]), _vm._v(" "), _c('div', {
    staticClass: "act-content"
  }, [_vm._v("国内第一批创投服务机构，国内第一批创投服务机构，国内第一批创投服务机构，国内第一批创投服务机构，国内第一批创投服务机构，拥有包含小饭桌ROADSHOW、小饭桌创业课程、小饭桌创服媒体、小饭局沙龙、产业专家库、社群等明星产品")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-67edf048"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/FzgHomeMobile.vue
// module id = 232
// module chunks = 0